export const allowedMime = ['application/pdf', 'image/jpeg', 'image/png']

// 100 MXN
export const MIN_AMOUNT = 100

// 10 MB
export const MAX_FILE_BYTES = 10 * 1024 * 1024

/** Orden estable para armar el schema completo por defecto */
export const CASHOUT_FIELD_KEYS = [
  'amount',
  'name',
  'last_name',
  'card_number',
  'clabe',
  'bank_id',
  'bank_statement',
  'csf',
  'password',
]
